import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { ReduxStateType } from "redux-store/types";

interface InitialState {
  status?: ReduxStateType;
  data?: any[];
}

const initialState: InitialState = {
  status: ReduxStateType.INIT,
  data: [],
};

const getListRecruitmentRequirementSlice = createSlice({
  name: "getListRecruitmentRequirement",
  initialState,
  reducers: {
    getListRecruitmentRequirementStart: (state) => {
      state.status = ReduxStateType.LOADING;
    },
    getListRecruitmentRequirementSuccess: (
      state,
      action: PayloadAction<{
        data: any[];
      }>
    ) => {
      state.status = ReduxStateType.SUCCESS;
      state.data = [...(state.data ?? []), ...action.payload.data];
    },
    getListRecruitmentRequirementFailed: (state) => {
      state.status = ReduxStateType.ERROR;
      state.data = [];
    },
    resetListRecruitmentRequirement: () => initialState,
  },
});

export const {
  getListRecruitmentRequirementStart,
  getListRecruitmentRequirementSuccess,
  getListRecruitmentRequirementFailed,
  resetListRecruitmentRequirement,
} = getListRecruitmentRequirementSlice.actions;

export default getListRecruitmentRequirementSlice.reducer;
